module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst additionalAttributes = []\nconst additionalClasses = []\nif(model.isEmpty){\nadditionalClasses.push('isEmpty')\n}\nif(additionalClasses.length > 0){\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\n}\n%><div <%- additionalAttributes.join(' ') %>><%\n%><p class=\"isEmptyMessage\"><%= model.emptyMessage || '' %></p><%\n%><div class=\"chartContent\"><%\nif(model.headline){\n%><div class=\"title\"><%= model.headline %></div><%\n}\n%><div class=\"baseInformation\"></div><%\n%><div class=\"canvasContainer\"><%\n%><canvas class=\"chart\"></canvas><%\n%></div><%\n%><div class=\"legend\"></div><%\n%></div><%\n%></div>"
  , __filename = "components/templates/crew/employeeReports/charts/hourDetailsDoughnut.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const additionalAttributes = []
const additionalClasses = []
if(model.isEmpty){
additionalClasses.push('isEmpty')
}
if(additionalClasses.length > 0){
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)
}

    ; __line = 10
    ; __append("<div ")
    ; __append( additionalAttributes.join(' ') )
    ; __append(">")
    ; 

    ; __line = 11
    ; __append("<p class=\"isEmptyMessage\">")
    ; __append(escapeFn( model.emptyMessage || '' ))
    ; __append("</p>")
    ; 

    ; __line = 12
    ; __append("<div class=\"chartContent\">")
    ; 
if(model.headline){

    ; __line = 14
    ; __append("<div class=\"title\">")
    ; __append(escapeFn( model.headline ))
    ; __append("</div>")
    ; 
}

    ; __line = 16
    ; __append("<div class=\"baseInformation\"></div>")
    ; 

    ; __line = 17
    ; __append("<div class=\"canvasContainer\">")
    ; 

    ; __line = 18
    ; __append("<canvas class=\"chart\"></canvas>")
    ; 

    ; __line = 19
    ; __append("</div>")
    ; 

    ; __line = 20
    ; __append("<div class=\"legend\"></div>")
    ; 

    ; __line = 21
    ; __append("</div>")
    ; 

    ; __line = 22
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/crew/employeeReports/charts/hourDetailsDoughnut.ejs

}